var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-4",attrs:{"no-body":"","img-top":""}},[_c('b-skeleton-img',{attrs:{"animation":"wave","card-img":"top","aspect":"3:2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }